import { useAuthBearerFetch } from "matsuri-hooks"
import { m2mCleaning_cleanerV3 } from "@/endpoints/m2m-cleaning.cleaner-v3"
import { PlacementDetail } from "@/model/placement"

export type PlacementDetailsByOperationIdOutput = Record<
    string, // cleaningId
    PlacementDetail | undefined // undefined if placement is not found
>

export const usePlacementDetailsByOperationId = (
    token: string,
    operationIds: string[]
) => {
    const endpoint =
        m2mCleaning_cleanerV3.listPlacementDetailsByCleaningIdsForCleaner

    return useAuthBearerFetch<PlacementDetailsByOperationIdOutput>(
        token,
        operationIds.length > 0 ? endpoint() : null,
        {
            method: endpoint.method,
            body: JSON.stringify({ cleaningIds: operationIds })
        }
    )
}
